import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'TEMSA',
  logo: { name: 'TEMSA', src: '/logo/temsacard.png' },
  portrait: { src: '/photo/portrait-erdinc-ugurlu.png', alt: 'Erdinç Uğurlu' },
  quote: [
    'Digitopia’s Digital Maturity Index has been a key element in structuring our digital '
    + 'transformation. It provided us with a clear, objective view of where we stand and how '
    + 'we compare, both within our holding and across the industry. More importantly, it '
    + 'enabled us to track progress over time and align our digital investments with '
    + 'measurable outcomes. This structured approach brings clarity, focus, and confidence '
    + 'to our transformation efforts.',
  ],
  attribution: 'Erdinç Uğurlu, CIO, TEMSA',
  story: 'temsa',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 1
